import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import type { ChatMessageEmojiInputDeleteReaction } from '@/components/Chat/ChatMessageEmojiInput';
import { ChatMessageEmojiInputFragment } from '@/components/Chat/ChatMessageEmojiInput.utils';
import { type ResultOf, readFragment } from '@/gql/graphql';
import useAuthStore from '@/stores/useAuthStore';

export default function delete_message_reaction_by_pk(
  parent: {
    delete_message_reaction_by_pk: ResultOf<
      typeof ChatMessageEmojiInputDeleteReaction
    >['delete_message_reaction_by_pk'];
  },
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  const message = readFragment(
    ChatMessageEmojiInputFragment,
    parent.delete_message_reaction_by_pk?.message,
  );
  const personId = useAuthStore.getState().uid;

  if (!message || !personId) {
    return;
  }

  cache.writeFragment(ChatMessageEmojiInputFragment, message, {
    personId,
  });
}
